//
//
//
//

export default {
  name: "CooperativeManagement",
};
